<template>
  <div
  class="flex flex-col-reverse tablet:flex-row
  tablet:justify-between tablet: px-5 pb-2 text-center">
    <a href="https://www.mibuilding.eu">mibuilding.eu</a>
    <p class="">
      built with <em class="fas fa-heart text-red-light"></em> in Tallinn, Estonia
    </p>
  </div>
</template>

<script>
export default {
    name: 'Footer'
};
</script>

<style lang="scss" scoped>
</style>
